import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/managementOfWeb2dot0Tools'

export default function managementOfWeb20Tools() {
  return <ProjectLayout data={data} />
}
